import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router-dom'
import './Button.css';


class Button extends Component {
  render() {
    let activeClasses = "button";
		if (this.props.pullRight) activeClasses += ' button__right';
		if (this.props.hollow) activeClasses += ' button__hollow';
    if (this.props.makeFull) activeClasses += ' button__full';
    if (this.props.center) activeClasses += ' button__center';
    if (this.props.allowHover) activeClasses += ' button__hover';
    if (this.props.success) activeClasses += ' button--green';
    return (
      <div className="">
        {
          this.props.whereTo && !this.props.type &&
          <Link
            to={this.props.whereTo}
            className={activeClasses}>
            {this.props.text}
          </Link>
        }
        {
          !this.props.whereTo && !this.props.type &&
          <p
            onClick={this.props.onClick}
            className={activeClasses}>
            {this.props.text}
          </p>
        }
        {
          this.props.type &&
          <button
            type={this.props.type}
            onClick={this.props.onClick}
            className={activeClasses}>
            {this.props.text}
          </button>
        }
      </div>
    );
  }
}

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  unwrap: PropTypes.bool,
  whereTo: PropTypes.string,
  hollow: PropTypes.bool,
  center: PropTypes.bool,
  makeFull: PropTypes.bool,
  pullRight: PropTypes.bool
};


export default Button;



/** WEBPACK FOOTER **
 ** ./src/components/Button/index.js
 **/